<template>
  <div>
    <a
      href
      class="back-link font-bold font-bai"
      @click.prevent="setStep('step1')"
      >{{ $t("app.Retour au panier") }}</a
    >
    <div class="row">
      <div class="col-lg-8">
        <div class="payment-left">
          <h1 class="font-bold font-balo">{{ $t("app.Paiement") }}</h1>
          <div class="destep2 font-bai">
            {{
              $t(
                "app.Complétez les champs d’information et choisissez votre mode de paiement :"
              )
            }}
          </div>
          <ValidationObserver
            v-slot="{ handleSubmit }"
            @submit.prevent="submitObserver()"
            ref="observer"
          >
            <form
              action
              id="paymentForm"
              class="font-bai form-default"
              @submit.prevent="handleSubmit(onSubmit)"
              ref="paymentForm"
            >
              <h2 class="font-bold">
                {{ $t("app.reservation on behalf of") }}:
              </h2>
              <div class="form-group">
                <validation-provider rules="required" v-slot="{ errors }">
                  <input
                    type="text"
                    class="form-control"
                    name="first_name"
                    v-model="form.first_name"
                    :placeholder="$t('app.Prénom')"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                  <span class="error">
                    {{ errors[0] ? `${$t("app.First name is required")}` : "" }}
                  </span>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider rules="required" v-slot="{ errors }">
                  <input
                    type="text"
                    class="form-control"
                    name="last_name"
                    v-model="form.last_name"
                    :placeholder="$t('app.Nom')"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                  <span class="error">
                    {{ errors[0] ? `${$t("app.Last name is required")}` : "" }}
                  </span>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider rules="required|email" v-slot="{ errors }">
                  <input
                    type="email"
                    class="form-control"
                    name="email"
                    v-model="form.email"
                    :placeholder="$t('app.Adresse Email')"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                  <span class="error">
                    {{
                      errors[0] ? `${$t("app.Email address is required")}` : ""
                    }}
                  </span>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider rules="required" v-slot="{ errors }">
                  <input
                    type="tel"
                    class="form-control"
                    name="tel"
                    v-model="form.tel"
                    :placeholder="$t('app.Téléphone')"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                  <span class="error">
                    {{ errors[0] ? `${$t("app.Telephone is required")}` : "" }}
                  </span>
                </validation-provider>
              </div>
              <div class="payment-type">
                <h2 class="font-bold">{{ $t("app.Mode de paiement") }}</h2>
                <p>
                  {{ $t("app.Je paie") }}
                  <b>
                    {{ $t("app.un acompte pour confirmer ma réservation*") }}
                  </b>
                  .
                  {{ $t("app.the rest to be paid will be paid on site") }}
                </p>
                <div class="paytype-list text-center">
                  <ul class="list-inline">
                    <li class="item-inline">
                      <validation-provider vid="form.method" rules>
                        <input type="hidden" v-model="form.method" />
                        <a
                          @click.prevent="onSelectPaymentMethod('creditCard')"
                          :class="{
                            active: form.method === 'creditCard'
                          }"
                        >
                          <div class="image payment-online"></div>
                          {{ $t("app.Payer par carte bleue") }}
                          <span class="payment-online-des">
                            {{ $t("app.Acompte de 50 %") }}
                          </span>
                        </a>
                      </validation-provider>
                    </li>
                    <li class="item-inline" v-if="!isDisabledMethodBank">
                      <a
                        @click.prevent="onSelectPaymentMethod('bank')"
                        :class="{
                          active: form.method === 'bank'
                        }"
                      >
                        <div class="image payment-bank"></div>
                        {{ $t("app.Virement") }}
                        <span class="payment-bank-des">
                          {{ $t("app.Acompte de 30 %") }}
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="bank-details-text">
                  {{ $t("app.bank details description") }}
                </div>
                <div class="card-payments" v-if="form.method === 'creditCard'">
                  <div class="form-group">
                    <label>{{ $t("app.Numéro de carte") }}</label>
                    <div
                      id="card-number-placeholder"
                      class="pci-field"
                      :class="{
                        'pci-in-valid': !isCardNumberValid,
                        'pci-loaded': isSecureFieldsLoaded
                      }"
                    ></div>
                    <span class="error" v-if="!isCardNumberValid">
                      {{ $t("app.Card number is required") }}
                    </span>
                  </div>
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <validation-provider
                          rules="required_if:form.method,creditCard|max:2"
                          v-slot="{ errors }"
                        >
                          <label>
                            {{ $t("app.Date expiration") }}
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            v-model="form.creditCard.month"
                            :placeholder="$t('app.Month')"
                            :class="{
                              'is-invalid': errors[0]
                            }"
                          />
                          <span class="error">
                            {{
                              errors[0] ? `${$t("app.Month is required")}` : ""
                            }}
                          </span>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <validation-provider
                          :rules="
                            `required_if:form.method,creditCard|numeric|length:4|min_value:${currentYear}`
                          "
                          v-slot="{ errors }"
                        >
                          <label>
                            <br />
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            v-model="form.creditCard.year"
                            :placeholder="$t('app.Year')"
                            :class="{
                              'is-invalid': errors[0]
                            }"
                          />
                          <span class="error">
                            {{
                              errors[0] ? `${$t("app.Year is required")}` : ""
                            }}
                          </span>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group relative-section codesform">
                        <label>
                          {{ $t("app.Code de sécurité") }}
                        </label>
                        <div
                          id="cvv-placeholder"
                          class="pci-field"
                          :class="{
                            'pci-in-valid': !isCvvValid,
                            'pci-loaded': isSecureFieldsLoaded
                          }"
                        ></div>
                        <span class="error" v-if="!isCvvValid">
                          {{ $t("app.Cvv is required") }}
                        </span>

                        <img
                          class="scuritycard"
                          src="../../assets/images/scuritycard.png"
                          alt
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <validation-provider
                      rules="required_if:form.method,creditCard"
                      v-slot="{ errors }"
                    >
                      <label>{{ $t("app.Nom du titulaire") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.creditCard.name"
                        :class="{
                          'is-invalid': errors[0]
                        }"
                      />
                      <span class="error">
                        {{ errors[0] ? `${$t("app.Name is required")}` : "" }}
                      </span>
                    </validation-provider>
                  </div>
                </div>
                <!-- <p class="note">
                  <i>
                    {{
                    $t(
                    "app.*Remboursable jusqu’à 30 jours avant le début du séjour"
                    )
                    }}
                  </i>
                </p> -->
                <div class="policy">
                  <validation-provider
                    rules="required|checked"
                    v-slot="{ errors }"
                  >
                    <label
                      class="checkbox-custom font-bai"
                      :class="{
                        'is-invalid': errors[0],
                        active: form.is_accept_condition
                      }"
                    >
                      <input
                        type="checkbox"
                        name="is_accept_condition"
                        v-model="form.is_accept_condition"
                      />
                      <div class="des">
                        <h4>
                          {{ $t("app.J’accepte les") }}
                          <a href target="_blank">
                            <b>
                              {{ $t("app.Conditions Générales de Vente") }}
                            </b>
                          </a>
                        </h4>
                        <span class="error">
                          {{
                            errors[0]
                              ? `${$t("app.This field is required")}`
                              : ""
                          }}
                        </span>
                      </div>
                    </label>
                  </validation-provider>

                  <validation-provider v-slot="{ errors }">
                    <label
                      class="checkbox-custom font-bai"
                      :class="{
                        'is-invalid': errors[0],
                        active: form.is_accept_atlantica
                      }"
                    >
                      <input
                        type="checkbox"
                        name="is_accept_atlantica"
                        v-model="form.is_accept_atlantica"
                      />
                      <div class="des">
                        <h4>
                          {{
                            $t(
                              "app.J’accepte de recevoir des offres ou informations de la part d’Atlantica Parc"
                            )
                          }}
                        </h4>
                        <span class="error">
                          {{
                            errors[0]
                              ? `${$t("app.This field is required")}`
                              : ""
                          }}
                        </span>
                      </div>
                    </label>
                  </validation-provider>
                </div>
                <div class="text-center">
                  <vue-recaptcha
                    ref="recaptcha"
                    @verify="onCaptchaVerified"
                    @expired="resetRecaptcha"
                    :sitekey="siteKey"
                    :loadRecaptchaScript="true"
                  ></vue-recaptcha>
                  <button
                    class="btn payment-final font-bold"
                    type="submit"
                    ref="paymentButton"
                    :disabled="isDisabledSubmitButton"
                  >
                    {{ $t("app.Procéder au paiement") }}
                  </button>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
      <div class="col-lg-4">
        <CartSidebar :submitPaymentForm="onTriggerSubmitForm" />
      </div>
    </div>
  </div>
</template>

<script>
import CartSidebar from "@/components/cart/CartSidebar";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapActions, mapState } from "vuex";
import { get, first, map, find } from "lodash";
import {
  checkIsValidDatePayment,
  formatBookDate
} from "@/helper/calculateDays";
import moment from "moment";
import VueRecaptcha from "vue-recaptcha";
import { siteKey } from "@/helper/config";
import { PAYMENT_GATEWAY_PUBLIC_KEY } from "@/api/config";
const currentDate = new Date();
export default {
  name: "PaymentMethod",
  components: {
    CartSidebar,
    ValidationProvider,
    ValidationObserver,
    VueRecaptcha
  },
  data() {
    return {
      isSecureFieldsLoaded: false,
      isDisabledMethodBank: false,
      currentYear: currentDate.getFullYear(),
      verifyCaptcha: false,
      siteKey: siteKey,
      isCardNumberValid: true,
      isCvvValid: true,
      total: "",
      isDisabledSubmitButton: false,
      form: {
        first_name: "",
        last_name: "",
        email: "",
        tel: "",
        is_accept_atlantica: null,
        is_accept_condition: null,
        method: "creditCard",
        creditCard: {
          number: "",
          month: "",
          year: "",
          cvv: "",
          name: ""
        }
      }
    };
  },
  computed: {
    ...mapState({
      campingClubs: state => get(state, "campingClubs.list", []),
      types: state => get(state, "types.list", []),
      categories: state => get(state, "categories.list", []),
      cart: state => get(state, "cart.cart"),
      lang: state => get(state, "app.lang", "fr"),
      filter: state => get(state, "hotels.filter", {}),
      paymentConfiguration: state => get(state, "cart.paymentConfiguration"),
      currency: state => get(state, "app.currency"),
      allReferences: state => get(state, "hotels.allReferences", [])
    })
  },
  mounted() {
    this.isDisabledMethodBank = this.checkIsDisabledPaymentBank();
    this.total = this.getTotalPrice();
    this.getPaymentConfiguration().then(config => {
      console.log("MEWS PAYMENT CONFIG:", JSON.stringify(config));
    });
    const styles = {
      // set style to one of the elements
      cardNumber: {
        background: "#ffffff",
        // border: "1px solid #e0e0e0",
        boxSizing: "border-box",
        borderRadius: "40px",
        height: "50px",
        padding: "0 16px",
        fontWeight: 400,
        fontSize: "14px",
        color: "#828282"
        // fontFamily: "Bai Jamjuree"
      },
      cvv: {
        background: "#ffffff",
        // border: "1px solid #e0e0e0",
        boxSizing: "border-box",
        borderRadius: "40px",
        height: "50px",
        padding: "0 16px",
        fontWeight: 400,
        fontSize: "14px",
        color: "#828282"
        // fontFamily: "Bai Jamjuree"
      },
      "cardNumber.invalid": {
        // borderColor: "#dc3545",
        paddingRight: "calc(1.5em + 0.75rem)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right calc(0.375em + 0.1875rem) center",
        backgroundSize: "calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)"
      },
      "cvv.invalid": {
        // borderColor: "#dc3545",
        paddingRight: "calc(1.5em + 0.75rem)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right calc(0.375em + 0.1875rem) center",
        backgroundSize: "calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)"
      }
    };
    // eslint-disable-next-line
    const secureFields = new SecureFields();
    const _this = this;
    // console.log("PAYMENT_GATEWAY_PUBLIC_KEY", PAYMENT_GATEWAY_PUBLIC_KEY);
    secureFields.initTokenize(
      PAYMENT_GATEWAY_PUBLIC_KEY,
      //get(this.paymentConfiguration, "PaymentGateway.PublicKey"),
      {
        cardNumber: "card-number-placeholder",
        cvv: "cvv-placeholder"
      },
      {
        styles: styles
        // focus: "cardNumber"
      }
    );
    secureFields.on("ready", function() {
      secureFields.setPlaceholder("cardNumber", "");
      secureFields.setPlaceholder("cvv", _this.$i18n.t("app.Code"));
      _this.isSecureFieldsLoaded = true;
    });
    this.secureFields = secureFields;
    this.secureFields.on("change", function(data) {
      const {
        fields: { cardNumber, cvv },
        event
      } = data;
      if (event.field === "cardNumber") {
        _this.isCardNumberValid = cardNumber.valid;
      }
      if (event.field === "cvv") {
        _this.isCvvValid = cvv.valid;
      }
    });
  },
  methods: {
    ...mapActions("cart", [
      "createReservation",
      "getPaymentConfiguration",
      "setStep",
      "createBookingByBank",
      "getCardDataFromTransaction"
    ]),
    getTotalPrice() {
      const occupancyPrices = first(this.cart.occupancyPrices);
      const pricingObject = first(get(occupancyPrices, "Pricing", []));
      const totalPrice = get(
        pricingObject,
        `Price.TotalAmount.${this.currency.code}.GrossValue`
      );
      return totalPrice || 0;
    },
    onSelectPaymentMethod(method) {
      this.form = {
        ...this.form,
        method
      };
    },
    async onSubmit() {
      if (this.isDisabledSubmitButton) return;
      // start submit
      this.isDisabledSubmitButton = true;
      if (!this.verifyCaptcha) {
        this.$bvToast.toast(this.$i18n.t("app.Please verify captcha"), {
          title: this.$i18n.t("app.Error"),
          variant: "danger",
          solid: true
        });
        this.isDisabledSubmitButton = false;
        return;
      }
      if (
        !checkIsValidDatePayment(this.cart.info.dateFrom, this.cart.info.dateTo)
      ) {
        this.$bvToast.toast(this.$i18n.t("app.Please correct your dates"), {
          title: this.$i18n.t("app.Error"),
          variant: "danger",
          solid: true
        });
        this.isDisabledSubmitButton = false;
        return;
      }
      const occupancyPrices = first(this.cart.occupancyPrices);
      const pricingObject = first(get(occupancyPrices, "Pricing", []));
      const childCount =
        Number(this.cart.info.child) + Number(this.cart.info.child1);
      const notes =
        Number(this.cart.info.child1) > 0
          ? this.$i18n.t("Avec X bébé", { X: this.cart.info.child1 })
          : "";
      let reservationData = {
        Customer: {
          Email: this.form.email,
          FirstName: this.form.first_name,
          LastName: this.form.last_name,
          Telephone: this.form.tel
        },
        Reservations: [
          {
            RoomCategoryId: this.cart.room.RoomCategoryId,
            StartUtc: formatBookDate(this.cart.info.dateFrom),
            EndUtc: formatBookDate(this.cart.info.dateTo),
            RateId: pricingObject.RateId,
            AdultCount: this.cart.info.adult || 0,
            ChildCount: childCount || 0,
            Notes: notes
          }
        ]
      };
      if (this.cart.voucher) {
        reservationData.Reservations[0] = {
          ...reservationData.Reservations[0],
          VoucherCode: this.cart.voucher
        };
      }
      if (this.cart.products && this.cart.products.length) {
        reservationData.Reservations[0] = {
          ...reservationData.Reservations[0],
          ProductIds: map(this.cart.products, product => product.Id)
        };
      }
      const _this = this;
      if (this.form.method === "creditCard") {
        this.secureFields.submit();
        this.secureFields.on("validate", function(event) {
          const {
            fields: { cardNumber, cvv }
          } = event;
          _this.isCardNumberValid = cardNumber.valid;
          _this.isCvvValid = cvv.valid;
        });
        this.secureFields.on("success", async function(data) {
          if (data.transactionId) {
            const expirationDate = moment(
              `${_this.form.creditCard.year}-${_this.form.creditCard.month}`,
              "YYYY-MM"
            );
            const isValidExpirationDate = expirationDate.diff(moment(), "days");
            if (isValidExpirationDate > 0) {
              _this.createReservation(reservationData).then(async () => {
                //reservationResponse
                _this.secureFields.destroy();
                // send to server
                // const type = find(_this.types, item => item.id === _this.filter.type);
                // const camping = find(
                //   _this.campingClubs,
                //   item => item.id === _this.filter.camping
                // );
                // const categorie = find(
                //   _this.categories,
                //   item => item.id === _this.filter.categorie
                // );
                // await _this.createBookingByBank({
                //   ...reservationData,
                //   ..._this.filter,
                //   type: get(type, "title.rendered", ""),
                //   camping: get(camping, "title.rendered", ""),
                //   categorie: get(categorie, "title.rendered", ""),
                //   voucher: _this.cart.voucher,
                //   products: map(_this.cart.products, product =>
                //     _this.getTranslate(product.Name)
                //   ),
                //   total: `${_this.total} ${_this.currency.code}`,
                //   reservation: get(reservationResponse, 'Id'),
                //   reference: get(find(_this.allReferences, item => item.id === get(reservationResponse, 'Reservations.0.RoomCategoryId')), 'key'),
                //   status: 3, // paid
                // });
                _this.isDisabledSubmitButton = false;
              });
            } else {
              _this.$bvToast.toast(
                _this.$i18n.t("app.Please correct expiration"),
                {
                  title: _this.$i18n.t("app.Error"),
                  variant: "danger",
                  solid: true
                }
              );
              _this.isDisabledSubmitButton = false;
              return;
            }
          }
        });
      } else {
        const type = find(this.types, item => item.id === this.filter.type);
        const camping = find(
          this.campingClubs,
          item => item.id === this.filter.camping
        );
        const categorie = find(
          this.categories,
          item => item.id === this.filter.categorie
        );
        await this.createBookingByBank({
          ...reservationData,
          ...this.filter,
          type: get(type, "title.rendered", ""),
          camping: get(camping, "title.rendered", ""),
          categorie: get(categorie, "title.rendered", ""),
          voucher: this.cart.voucher,
          products: map(this.cart.products, product =>
            this.getTranslate(product.Name)
          ),
          total: `${this.total} ${this.currency.code}`,
          reference: get(
            find(
              this.allReferences,
              item => item.id === get(this, "cart.room.RoomCategoryId", "")
            ),
            "key"
          ),
          status: 1 // processing
        });
        _this.isDisabledSubmitButton = false;
      }
    },
    checkIsDisabledPaymentBank() {
      const dateFrom = moment(this.cart.info.dateFrom);
      const dateNow = moment();
      const diff = dateFrom.diff(dateNow, "days");
      return diff < 7;
    },
    onTriggerSubmitForm() {
      this.$refs.paymentButton.click();
    },
    onCaptchaVerified(response) {
      if (response) this.verifyCaptcha = true;
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
    },
    // onClickButtonSubmit() {
    //   if (this.form.method === "creditCard") {
    //     this.secureFields.submit();
    //     const _this = this;
    //     this.secureFields.on("validate", function(event) {
    //       const {
    //         fields: { cardNumber, cvv }
    //       } = event;
    //       _this.isCardNumberValid = cardNumber.valid;
    //       _this.isCvvValid = cvv.valid;
    //     });
    //   }
    // },
    getTranslate(object) {
      if (this.lang === "fr" && get(object, "fr-FR")) {
        return get(object, "fr-FR");
      }
      return get(object, "en-US");
    },
    async submitObserver() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        this.isDisabledSubmitButton = false;
        return;
      }
    }
  },
  watch: {
    cart: function() {
      this.total = this.getTotalPrice();
    },
    currency: function() {
      this.total = this.getTotalPrice();
    }
  }
};
</script>
